import {
    Modal,
    Form,
    Card,
    Button,
} from "react-bootstrap";
import React from "react";

import { useForm } from "react-hook-form";



export default function PatientInfoModal(props) {

    const bookingData = props.bookingData;
    const clinic = props.clinicData;
    
    const handleClose = () => props.setShow(false);

    const {register, handleSubmit} = useForm();

    const onSubmit = (data) => {
        if(data.message){
            bookingData.message= data.message;
        }
        props.setBookingData(bookingData);
        props.setShowNextModal(true);
        handleClose();
    }

        return (
          <Modal show={true} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title >Review</Modal.Title>
            </Modal.Header>
            <Modal.Body className='mx-3'>
                <Card text='light' bg='secondary' className="text-center py-3 px-3 my-3">
                    Please take time to look through and ensure that the information is correct.
                </Card>

                <Card bg='light' className="text-center py-3 px-3 my-3">
                <i className="far fa-calendar-alt"> Your appointment date and time: </i><br/>
                    <h3 className="text-primary">
                        {(bookingData.time.getDate())}/{(bookingData.time.getMonth()+1)}/{(bookingData.time.getFullYear())} at {(bookingData.time.getHours()<10?'0':'') + bookingData.time.getHours() + ':00'} 
                    </h3>
                </Card>
                
                <Card  bg='light' className="text-center py-3 px-3 my-3">
                <i class="fas fa-tooth"> Treatment:</i>
                    <h4 className='my-2'>{bookingData.treatment}</h4>
                </Card>
                
                <Card  bg='light' className="text-center py-3 px-3 my-3">
                    <i class="fas fa-clinic-medical"> Clinic:</i>
                    <h4 className='my-2'>{clinic.clinic_name}</h4>
                </Card>
                
                <Card  bg='light' className="py-3 px-3 my-3">
                <i className="fas fa-user mb-3"> Your details:</i>
                    <h6>Name: {bookingData.first_name} {bookingData.last_name}</h6>
                    <h6>Phone: {bookingData.phone} </h6>
                    <h6>Email: {bookingData.email} </h6>
                </Card>
                <Form onSubmit={handleSubmit(onSubmit)}>
                            <Form.Group controlId="description">
                                {/* <Form.Label>Message</Form.Label> */}
                                <Form.Control  as="textarea" rows="3" name="message" placeholder="Feel free to write a message to the clinic." ref={register ()} />
                            </Form.Group> 
                            <Button className='rounded-pill h5' variant="primary" type="submit" size='lg' block>
                                Confirm
                            </Button>
                        </Form>
            </Modal.Body>
          </Modal>  
        );
      }
    